import { BodyText } from '@/components/BodyText';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { TableBody, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import { StyledHeaderCell, StyledTable, StyledTableCell, StyledTableRow } from './NsnTable';

const SubsectionHeader = styled(BodyText)(({ theme }) => ({
  display: 'block',
  color: theme.palette.text.secondary,
  marginBottom: '8px',
}));

interface ReportParametersTableProperties {
  partNumber: string;
  description: string | null | undefined;
  status: string;
  creatorEmail?: string;
}

export const ReportParametersTable = ({
  partNumber,
  description,
  status,
  creatorEmail,
}: ReportParametersTableProperties) => {
  const { selfAwareEmail } = useGetCurrentUser();

  return (
    <>
      <SubsectionHeader>Report Parameters</SubsectionHeader>
      <StyledTable size='small'>
        <TableHead>
          <TableRow>
            <StyledHeaderCell sx={{ width: '17.5%' }}>Part Number</StyledHeaderCell>
            <StyledHeaderCell sx={{ width: '32.5%' }}>Description</StyledHeaderCell>
            <StyledHeaderCell sx={{ width: '90px' }}>Status</StyledHeaderCell>
            <StyledHeaderCell sx={{ width: '150px' }}>Created By</StyledHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell sx={{ width: '17.5%' }}>{partNumber}</StyledTableCell>
            <StyledTableCell sx={{ width: '32.5%' }}>{description ?? 'none'}</StyledTableCell>
            <StyledTableCell sx={{ width: '90px' }}>{status}</StyledTableCell>
            <StyledTableCell sx={{ width: '150px' }}>
              {creatorEmail ? selfAwareEmail(creatorEmail) : 'none'}
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </StyledTable>
    </>
  );
};
